module.exports = __webpack_public_path__ + "img/header_title@2x.89d5965e.png";